<template>

    <b-row class="mb-2">

        <b-col sm="12" class="mb-2 d-flex align-items-center justify-content-between">

            <b-button variant="info" @click=" createModal = true; editingUser = {} ">Add Carrier Manager</b-button>
            <b-button variant="success" @click=" exportXls "><i class="fa fa-file-excel-o mr-2"></i>Export to Excel</b-button>
        </b-col>

        <b-col lg="6" class="mb-2">

            <b-form-select id="activeFilter" v-model="activeFilter">

                <option value="">-- Filter Active/Inactive --</option>
                <option value="active">Active Managers</option>
                <option value="inactive">Inactive (Deactivated) Managers</option>
            </b-form-select>
        </b-col>

        <b-col sm="12">

            <div class="table-responsive">

                <b-table bordered striped hover show-empty
                    ref="table"
                    :items=" items "
                    :fields=" fields "
                    :current-page=" currentPage "
                    :per-page=" 0 "
                    :sort-by.sync=" sortBy "
                    :sort-desc.sync=" sortDesc "
                    :busy=" loading "
                >

                    <template v-slot:cell(actions)="row">

                        <b-btn size="sm" @click=" editUser( row.item ) "><i class="fa fa-edit"></i></b-btn>
                        <b-btn size="sm" @click=" decommissionModal = true; editingUser = row.item "><i class="fa fa-trash"></i></b-btn>
                        <b-btn size="sm" @click=" passwordModal = true; editingUser = row.item "><i class="fa fa-envelope"></i></b-btn>
                    </template>
                </b-table>
            </div>
        </b-col>

        <b-col lg="6" >

            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
        </b-col>
        <b-col lg="6" class="text-right">

            {{ paginationText }}
        </b-col>

        <b-modal
            v-model=" passwordModal "
            size="lg"
            :title=" 'Reset Password' "
            :no-close-on-backdrop=" true "
            :ok-title=" 'Send it' "
            @ok=" sendPasswordEmail "
        >
            Are you sure you'd like to re-send the password reset email to {{ editingUser.firstname }}
        </b-modal>

        <b-modal
            v-model=" createModal "
            size="lg"
            :title=" createModalTitle "
            :no-close-on-backdrop=" true "
            :hide-footer=" true "
            >

            <carrier-manager-create :carrier=" carrier " :editingUser=" editingUser " :loadTable=" loadTable " ></carrier-manager-create>
        </b-modal>

        <decommission-modal v-model=" decommissionModal " :user=" editingUser " @confirm=" e => deactivateUser( true, e ) " />
    </b-row>
</template>

<script>

    import FormatsStrings from "../../../mixins/FormatsStrings";
    import FormatsDates from "../../../mixins/FormatsDates";
    import FormatsListData from "../../../mixins/FormatsListData";
    import EnrollmentStatuses from "../../../mixins/EnrollmentStatuses";
    import PaginatedTable from "../../../mixins/PaginatedTable";

    export default {

        components: {},
        mixins: [FormatsStrings, FormatsDates, FormatsListData, EnrollmentStatuses, PaginatedTable ],

        props: {

            carrier: {

                type     : Object,
                required : true
            },
        },
        data() {

            return {

                editingUser       : {},
                decommissionModal : false,
                createModal       : false,
                passwordModal     : false,

                activeFilter      : '',

                paginatedEndpoint : '/business/carrier_managers',
                fields: [

                    {
                        key: 'firstname',
                        label: 'First Name',
                        sortable: true
                    },
                    {
                        key: 'lastname',
                        label: 'Last Name',
                        sortable: true
                    },
                    {
                        key: 'email',
                        label: 'Email Address',
                        sortable: true,
                        formatter: this.formatEmail
                    },
                    {
                        key: 'active',
                        label: 'Active',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print',
                        sortable: false
                    }
                ]
            }
        },

        computed: {

            createModalTitle(){

                return this.editingUser.id ? `Update Carrier Manager ${this.editingUser.firstname} ${this.editingUser.lastname}` : `Create a new Carrier Manager for ${this.carrier.name}`;
            },
            appliedFilters(){ return `&ltc_carrier_id=${this.carrier.id}&active=${this.activeFilter}`; },
        },

        methods: {

            sendPasswordEmail(){

                let form = new Form({});
                form.post( '/business/carrier_managers/' + this.editingUser.id + '/resend-password-email' )
                    .then( () => {

                        this.loadTable();
                    });
            },
            deactivateUser( confirmed = false, reason = '' ){

                if( !confirmed ){

                    this.decommissionModal = true;
                    return;
                }

                let form = new Form({ reason });

                form.post( '/business/carrier_managers/' + this.editingUser.id + '/deactivate' )
                    .then( () => {

                        this.loadTable();
                    });
            },
            editUser( user ){

                this.createModal = true;
                this.editingUser = user;
            },
            loadTable(){
                // TODO: an incomplete implementation of the unified paginated table.. why did i do this lol.. come back to this at some point

                if( this.loading ) return;

                this.createModal = false;
                this.editingUser = {};
                this.loading = true;

                return axios.get( `${this.paginatedEndpoint}?${this.appliedFilters}${this.paginationControls}` )
                    .then( ({ data }) => {

                        this.totalRows = data.total;
                        this.items     = data.results || [];
                    })
                    .catch( err => {

                        this.totalRows = 0;
                        this.items     = [];
                    }).finally( () => this.loading = false );
            },
            exportXls() {

                window.open( `${this.paginatedEndpoint}?export=1${this.appliedFilters}`, '_blank' );
            },
        },
        watch: {

            appliedFilters(){

                this.loadTable();
            }
        }
    }
</script>
